import { useEffect, useState } from "react";
import { HallBody, HallContainer, HallTitle } from "../hall/style"
import { TableItem } from "../table/style"
import { FormContainer, FormInput, FormItem, FormLabel } from "../form/style";

export const Loader = () => {
  const [ count, setCount ] = useState<number[]>([])

  useEffect(()=>{
    const arr = []
    const windowWidth = window?.innerWidth;
    if (windowWidth) {
      const counter = Math.floor(windowWidth / 61) * 2;

      for (let index = 0; index < counter; index++) {
        arr.push(index)
      }

      setCount(arr);
    }
  }, [])
  return (
    <>
    <FormContainer>
      <FormItem>
        <FormLabel>Кол-во гостей</FormLabel>
        <FormInput/>
      </FormItem>
      <FormItem>
        <FormLabel>Длительность</FormLabel>
        <FormInput/>
      </FormItem>
    </FormContainer>
    <HallContainer>
      <HallTitle className="_skeleton">Загрузка</HallTitle>
      <HallBody>
        {count.map((item)=>{
          return <TableItem key={item} className="_skeleton"></TableItem>
        })}
      </HallBody>
    </HallContainer>
    <HallContainer>
      <HallTitle className="_skeleton">Загрузка</HallTitle>
      <HallBody>
        {count.map((item)=>{
          return <TableItem key={item} className="_skeleton"></TableItem>
        })}
      </HallBody>
    </HallContainer>
    </>
  )
}